<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
    name: "App"
};
</script>

<style>
.table-text-blue{
  color: #E9E9E9;
  cursor:pointer;
}
.table-text-gray{
  color: #E9E9E9;
}
.el-table th.is-leaf{
  background:#F9F9F9;
  /*border:1px solid #ebebeb;*/
}
.el-table, .el-table thead tr{
  border-top: 1px solid #ebebeb;
  border-left: 1px solid #ebebeb;
}
.el-table th.is-leaf{
  border-right: 1px solid #ebebeb;
}
.el-table--border th{
  border-color:#FFF;
  font-weight: normal;
}
.el-table--border{
  border:none;
}
.el-table,.el-table thead{
  color:#E9E9E9;
}
.el-table--border::after, .el-table--group::after{
  background-color: #fff;
}
/*.el-table td:first-child{*/
/*  border-left: 1px solid #E9E9E9;*/
/*}*/
.el-table td {
  border-right: 1px solid #E9E9E9;
}
.el-table__empty-block{
  border-right: 1px solid #E9E9E9;
}

.el-image-viewer__canvas{
  overflow: auto!important;
  position: relative;
  .el-image-viewer__img{
    top: 0;
    position: absolute;
    max-height: none!important;
  }
}
.el-image-viewer__wrapper{
  z-index:3500;
}
.editBox{
  width:80vw!important;
}

.el-empty__description{
  margin-top:0px!important;
}
.el-empty__description p{
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #2A2C30;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
}
.el-empty__bottom{
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: rgba(42,44,48,0.45);
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
  margin-top:6px!important;
}
.el-button-group>.el-button{
  border-radius: 13px!important;
  margin-left: 8px!important;
}
.el-button-group>.el-button:last-child{
  display: none!important;
}
.el-button-group>.el-button:not(:first-child):not(:last-child) {
  background: #3666DE;
  color:#fff;
}
/* 
.del_audio{
  width:190px!important;
  height:123px!important;
  top:70%!important;
  left:70%!important;
  .van-dialog__content{
    height:76px!important;
    min-height:76px!important;
    background-color:#fff;
    .van-dialog__message{
      font-family: PingFangSC-Regular;
      font-size: 15px;
      color: #353535;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
    }
  }
} */
</style>



// WEBPACK FOOTER //
// src/App.vue